export default __webpack_public_path__ + "static/media/Download-white.101f3b60.svg";